var map = {
	"./home-entertainment.de-CH.json": 1342,
	"./home-entertainment.de-DE.json": 1343,
	"./home-entertainment.en-CA.json": 1344,
	"./home-entertainment.en-GB.json": 1345,
	"./home-entertainment.en-IN.json": 1346,
	"./home-entertainment.en-ME.json": 1347,
	"./home-entertainment.en-US.json": 1348,
	"./home-entertainment.es-EM.json": 1349,
	"./home-entertainment.es-ES.json": 1350,
	"./home-entertainment.fr-BE.json": 1351,
	"./home-entertainment.fr-CA.json": 1352,
	"./home-entertainment.fr-CH.json": 1353,
	"./home-entertainment.nl-BE.json": 1354,
	"./home-entertainment.nl-NL.json": 1355,
	"./home-entertainment.pl-PL.json": 1356,
	"./home-entertainment.pt-BR.json": 1357
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1341;